import React from 'react';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';

export default function PrivacyPage() {
  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen">
        <article className="max-w-[800px] mx-auto px-4 sm:px-6 py-16 prose prose-neutral">
          <h1 className="news-masthead text-3xl font-bold mb-8">Privacy Policy</h1>
          <p className="text-xs text-[#5B616E] mb-8">Last updated: 31 October 2026</p>
          
          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly: account details (name, email), comments, bookmarks, and reading preferences. We also collect usage data including pages visited, time spent, and device information.</p>
          
          <h2>2. How We Use Your Information</h2>
          <p>We use your information to: provide and personalize our news service, send newsletters you've subscribed to, improve content recommendations, analyze content performance, and communicate service updates.</p>
          
          <h2>3. Data Sharing</h2>
          <p>We do not sell personal data. We may share data with: Apple (Sign in with Apple, In-App Purchase and WeatherKit in our iOS app), Google Firebase (authentication, push notifications and crash reports), analytics providers to improve our service, Stripe for purchases made outside the iOS app, and law enforcement when legally required.</p>
          
          <h2>4. Cookies</h2>
          <p>We use essential cookies for authentication and preferences, and analytics cookies to understand usage patterns. Neural News does not show advertising.</p>
          
          <h2>5. Your Rights</h2>
          <p>Under GDPR and applicable data protection laws, you have the right to: access your data, request corrections, request deletion, data portability, restrict processing, and withdraw consent. Contact us at privacy@neuralsignal.co.uk.</p>
          
          <h2>6. Data Retention</h2>
          <p>Account data is retained while your account is active. Analytics data is anonymized after 26 months. Deletion requests are processed within 30 days per GDPR requirements.</p>
          
          <h2>7. Security</h2>
          <p>We implement industry-standard security measures including encrypted data transmission (TLS), hashed passwords (bcrypt), role-based access controls, and regular security audits.</p>
          
          <h2>8. Changes</h2>
          <p>We may update this policy periodically. Material changes will be communicated via email to registered users and announced on the platform.</p>
          
          <h2>9. Contact</h2>
          <p>Data protection and privacy enquiries: privacy@neuralsignal.co.uk<br />Data controller: Neural Signal Corporation Limited, United Kingdom</p>
        </article>
      </main>
      <PublicFooter />
    </>
  );
}
